export default class Point {
  constructor (x, y) {
    this.x = x - 10
    this.y = y - 4
  }
}



// WEBPACK FOOTER //
// ./src/components/process/design/point.js